<template>
  <!-- 修改密码界面 -->
  <el-dialog v-dialogDrag :title="changePasswordTitle" :close-on-click-modal="changePasswordCloseOnClickModal" :show-close="changePasswordShowClose" width="32vw" :visible.sync="changePasswordVisible" v-if="changePasswordVisible">
    <el-form :model="dataForm" label-width="120px" label-suffix="：" :rules="common.openFormValidate ? dataFormRules : {}" ref="dataForm" label-position="right" class="el-form--standard">
      <el-row>
      <el-form-item label="旧密码" prop="oldpassword">
        <el-input v-model="dataForm.oldpassword" type="password" auto-complete="off" show-password></el-input>
      </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="新密码" prop="newpassword">
        <el-input v-model="dataForm.newpassword" type="password" auto-complete="off" show-password></el-input>
      </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input v-model="dataForm.confirmPassword" type="password" auto-complete="off" show-password></el-input>
      </el-form-item>
      </el-row>
      <el-row>
        <el-col v-if="messageShow" :span="19" :offset="5">
           <el-alert @close="changeMessageShow" :title="message" type="error" show-icon></el-alert>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="submitForm" :loading="editLoading" type="primary">保存</el-button>
      <el-button @click.native="close" v-if="actionType !== 'activateAccount'">取消</el-button>
    </div>

  </el-dialog>
</template>

<script>
import { getCookie } from '@/utils/cookie'
import {isPassWord} from '@/utils/validate'

export default {
  name: 'changePassword',
  props:{
    caller: { //调用者是谁，用户中心userCenter、企业首页enterpriseHome
      type: String,
      default: undefined,
      required: true
    },
  },
  //mounted： 在这发起后端请求，拿回数据，配合路由钩子做一些事情  （dom渲染完成 组件挂载完成 ）
  mounted() {
    if(this.caller === 'userCenter') {
      this.eventBus.$on('changePassword', (params) => {
        this.changePasswordVisible = params; // 打开弹窗
        this.changePasswordTitle = '修改密码'; // 修改弹窗标题
        this.changePasswordCloseOnClickModal = true; // 可以通过点击 modal 关闭 Dialog
        this.changePasswordShowClose = true; // 显示关闭按钮
        this.actionType = 'changePassword';

        this.dataForm.oldpassword='';
        this.dataForm.newpassword='';
        this.dataForm.confirmPassword='';
      });
    }

    if(this.caller === 'enterpriseHome') {
      this.eventBus.$on('activateAccount', (params) => {
        this.changePasswordVisible = params; // 打开弹窗
        this.changePasswordTitle = '激活用户'; // 修改弹窗标题
        this.changePasswordCloseOnClickModal = false; // 不可以通过点击 modal 关闭 Dialog
        this.changePasswordShowClose = false; // 不显示关闭按钮
        this.actionType = 'activateAccount';

        this.dataForm.oldpassword='';
        this.dataForm.newpassword='';
        this.dataForm.confirmPassword='';
      })
    }
  },
  beforeDestroy() {
    this.eventBus.$off('activateAccount')
  },
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.dataForm.newpassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    };
    return {
      changePasswordCloseOnClickModal : true,
      changePasswordShowClose : true,
      actionType:'', // 操作类型 修改密码changePassword、激活账户activateAccount

      changePasswordTitle: '修改密码',
      changePasswordVisible: false, // 编辑界面是否显示
      editLoading: false, //载入图标
      message:"",//错误信息
      messageShow:false,
      //初始化数据
      dataForm: {
        oldpassword: '',
        newpassword: '',
        confirmPassword: '',
      },
      //设置属性
      dataFormRules: {
        oldpassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newpassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          {validator: isPassWord, message: '密码长度为8-20位 必须包括大写字母、小写字母、特殊符号、数字中的任意两种', trigger: 'blur'}
          ],
        confirmPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
    }
  },
  methods: {
    close() {
      this.reset();
      this.changePasswordVisible = false
    },
    reset() {
      this.$refs['dataForm'].resetFields()
    },
    changeMessageShow(){
        this.messageShow=false
    },
    // 提交请求
    submitForm() {
      //this.$refs.XXX 获取ref绑定的节点
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.$confirm('您确定要' + this.changePasswordTitle + '吗？', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
            this.common.httpPost('修改密码', '/admin/system/user/changePassword', this.dataForm).then((res) => {
                  if(res.code===201){
                    this.message=res.message;
                    this.messageShow=true;
                    //设置10秒后消失
                    // setTimeout(this.changeMessageShow,10000);
                    return;
                  }else{
                    if (getCookie('userStatus') === '2' && this.actionType === 'activateAccount') {
                    this.changeMessageShow();
                    this.close();
                    this.$emit("activateSuccess");
                  } else {
                    this.changeMessageShow();
                    this.$message({
                      message: '密码修改成功',
                      type: 'success',
                    });
                    this.close();
                  }
                  }
              })
          }).catch(()=>{})
        }
      })
    },
  },
}
</script>

<style scoped>
.el-form--standard .el-input--suffix {
     width:100%;
}

.el-form-item {
  margin-bottom: 32px;
}

</style>



// WEBPACK FOOTER //
// src/components/MainLayout/components/UserManagement/changePassword.vue